import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { listDevice, findDevice, updateSensor, findSensor, findSensorId, findGateway, updateGateway, registerDevice, deleteDevice } from '../_actions/user_action';

import Button from '@mui/material/Button';

/* Checkbox */
import Checkbox from '@mui/material/Checkbox';

/* Form Group */
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

// Modal import
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

// 출력
import { CSVLink } from 'react-csv';
import moment from 'moment';
import 'moment/locale/ko';

const setting = require('../config/setting');
const prefixMainSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_main_type + "-";
const prefixNodeSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_node_type + "-";

// Modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    border: 'none',
    boxShadow: 14,
    p: 4
};

let arrayPrints = [];

function getTodayDateString() {
    var today = new Date();

    var year = today.getFullYear();
    var month = ('0' + (today.getMonth() + 1)).slice(-2);
    var day = ('0' + today.getDate()).slice(-2);

    var dateString = year + '-' + month + '-' + day;

    return dateString;
}

const Detail = (props) => {
    const dispatch = useDispatch();
    // console.log('Detail', props.userId);
    const userId = props.userId;
    console.log('Detail', userId);
    const userInfos = props.userInfos;

    const [userInfo, setUserInfo] = useState("");
    const [deviceListInfo, setDeviceListInfo] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const [gatewayListInfo, setGatewayListInfo] = useState([]);

    useEffect(() => {
        if (userId.length > 1) {
            console.log(userId);
            userInfos.forEach((info) => {
                console.log(info);
                if (userId === info.email) {
                    setUserInfo(info);
                }
            });
            
            let body = {
                id: userId
            };
    
            console.log('Detail - body:', body);
            dispatch(listDevice(body)).then(response => {
                console.log('Detail - response:', response);

                if (response.payload.listSuccess) {
                    let deviceList = response.payload.deviceList;

                    // sensorId가 있는 장비 리스트 필터링
                    let filteredDeviceList = deviceList.filter(item => item.sensorId);

                    // sensorId가 없고 sensorNumber에 'GW'가 포함된 장비 리스트 필터링
                    let gatewayDeviceList = deviceList.filter(item => 
                        !item.sensorId && item.sensorNumber && item.sensorNumber.includes(setting.sensor_no_main_type)
                    );

                    // 필터링된 디바이스 리스트 처리
                    filteredDeviceList.forEach((item, index) => {
                        console.log('listDevice', item);

                        let deviceState = "대기상태";
                        if (item.state === "Online") {
                            deviceState = "정상동작";
                        } else if (item.state === "Offline") {
                            deviceState = "점검필요";
                        } else if (item.state === "Error") {
                            deviceState = "통신오류";
                        }

                        let devicePowerMode = "ON";
                        if (item.currentPowerMode === 0) {
                            devicePowerMode = "OFF";
                        } else if (item.currentPowerMode === 1) {
                            devicePowerMode = "ON";
                        }

                        let deviceInfo = {
                            pSensor: item.sensorNumber,
                            pRegistDate: item.registerDate,
                            pState: deviceState,
                            pWillChangeDateNH3: item.willChangeDateNH3,
                            pWillChangeDateH2S: item.willChangeDateH2S,
                            pWillChangeDateTH: item.willChangeDateTH,
                            pDidChangeCountNH3: item.didChangeCountNH3,
                            pDidChangeCountH2S: item.didChangeCountH2S,
                            pDidChangeCountTH: item.didChangeCountTH,
                            pGuaranteeExpirationDate: item.guaranteeExpirationDate,
                            pCurrentPowerMode: devicePowerMode
                        };
                        arrayPrints[index] = deviceInfo;
                    });

                    // Gateway 리스트 설정
                    setGatewayListInfo(gatewayDeviceList);
                    setDeviceListInfo(filteredDeviceList);
                }
            })
            .catch((err) => console.log(err));
        }
    }, [userId, userInfos]);    

    // 장비 관리
    const headers = [
        { label: "장비 Part No.", key: "pSensor" },
        { label: "등록일", key: "pRegistDate" },
        { label: "장비상태", key: "pState" },
        { label: "센서 교환시기 (암모니아)", key: "pWillChangeDateNH3" },
        { label: "센서 교환시기 (황화수소)", key: "pWillChangeDateH2S" },
        { label: "센서 교환시기 (온습도)", key: "pWillChangeDateTH" },
        { label: "센서 교환횟수 (암모니아)", key: "pDidChangeCountNH3" },
        { label: "센서 교환횟수 (황화수소)", key: "pDidChangeCountH2S" },
        { label: "센서 교환횟수 (온습도)", key: "pDidChangeCountTH" },
        { label: "무상 AS 만료일", key: "pGuaranteeExpirationDate" },
        { label: "전원", key: "pCurrentPowerMode" }
    ];

    // 선택
    const [checkedList, setCheckedLists] = useState([]);
    const onCheckedElement = (checked, list, index) => {
        if (checked) {
            setCheckedLists([...checkedList, list]);
            setSelectedIndex(index);
        } else {
            setCheckedLists(checkedList.filter((el) => el !== list));
        }
    };

    const handlePrintSubmit = () => {
        // let message = "";

        if (checkedList.length === 0) {
            // message = "전체 등록 리스트를 출력하시겠습니까?";
            // if (!window.confirm(message))
                // return;
        }
    };

    const focusRefModifyWillChangeDateNH3 = useRef();
    const focusRefModifyWillChangeDateH2S = useRef();
    const focusRefModifyWillChangeDateTH = useRef();
    const focusRefModifyDidChangeCountNH3 = useRef();
    const focusRefModifyDidChangeCountH2S = useRef();
    const focusRefModifyDidChangeCountTH = useRef();

    const [inputsModifyDevice, setInputsModifyDevice] = useState({
        modifyDeviceSensorNumber: "",
        modifyWillChangeDateNH3: "",
        modifyWillChangeDateH2S: "",
        modifyWillChangeDateTH: "",
        modifyDidChangeCountNH3: "",
        modifyDidChangeCountH2S: "",
        modifyDidChangeCountTH: ""
    });

    const {
        modifyDeviceSensorNumber,
        modifyWillChangeDateNH3,
        modifyWillChangeDateH2S,
        modifyWillChangeDateTH,
        modifyDidChangeCountNH3,
        modifyDidChangeCountH2S,
        modifyDidChangeCountTH
    } = inputsModifyDevice;

    let alert_msg = "";

    // 장비 수정 Modal
    const [modifyDeviceOpen, setModifyDeviceOpen] = useState(false);
    const handleModifyDeviceOpen = (e) => {
        if (checkedList.length === 0) {
            alert_msg = "장비 리스트를 선택해주세요";
        } else if (checkedList.length !== 1) {
            alert_msg = "장비 리스트 중 하나만 선택해주세요";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        setInputsModifyDevice({
            modifyDeviceSensorNumber: deviceListInfo[selectedIndex].sensorNumber,
            modifyWillChangeDateNH3: deviceListInfo[selectedIndex].willChangeDateNH3,
            modifyWillChangeDateH2S: deviceListInfo[selectedIndex].willChangeDateH2S,
            modifyWillChangeDateTH: deviceListInfo[selectedIndex].willChangeDateTH,
            modifyDidChangeCountNH3: deviceListInfo[selectedIndex].didChangeCountNH3,
            modifyDidChangeCountH2S: deviceListInfo[selectedIndex].didChangeCountH2S,
            modifyDidChangeCountTH: deviceListInfo[selectedIndex].didChangeCountTH
        });
        setModifyDeviceOpen(true);
    };
    const handleModifyDeviceClose = () => setModifyDeviceOpen(false);

    const handleChangeModifyDevice = (e) => {
        console.log(e.target.name, e.target.value);

        let regex = /^[0-9\b -]{0,10}$/;
        if (e.target.name === 'modifyWillChangeDateNH3' || e.target.name === 'modifyWillChangeDateH2S' || e.target.name === 'modifyWillChangeDateTH') {
            if (!regex.test(e.target.value))
                return;
        }

        regex = /^[0-9]+$/;
        if (e.target.name === 'modifyDidChangeCountNH3' || e.target.name === 'modifyDidChangeCountH2S' || e.target.name === 'modifyDidChangeCountTH') {
            if (!regex.test(e.target.value))
                return;
        }

        const { value, name } = e.target;
        setInputsModifyDevice({
            ...inputsModifyDevice,
            [name]: value
        });
    };

    const handleModifyDeviceSubmit = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";

        const changeDevice = {
            sensorNumber: modifyDeviceSensorNumber,
            willChangeDateNH3: modifyWillChangeDateNH3,
            willChangeDateH2S: modifyWillChangeDateH2S,
            willChangeDateTH: modifyWillChangeDateTH,
            didChangeCountNH3: modifyDidChangeCountNH3,
            didChangeCountH2S: modifyDidChangeCountH2S,
            didChangeCountTH: modifyDidChangeCountTH
        };

        for (var key in changeDevice) {
            modify_errors = "";

            if (changeDevice[key].length === 0 || changeDevice[key] === undefined) {
                modify_key = key;

                if (key === 'willChangeDateNH3') {
                    modify_errors = "[교환시기 - 암모니아]가 없습니다.";
                } else if (key === 'willChangeDateH2S') {
                    modify_errors = "[교환시기 - 황화수소]가 없습니다.";
                } else if (key === 'willChangeDateTH') {
                    modify_errors = "[교환시기 - 온/습도]가 없습니다.";
                } else if (key === 'didChangeCountNH3') {
                    modify_errors = "[교환횟수 - 암모니아]가 없습니다.";
                } else if (key === 'didChangeCountH2S') {
                    modify_errors = "[교환횟수 - 황화수소]가 없습니다.";
                } else if (key === 'didChangeCountTH') {
                    modify_errors = "[교환횟수 - 온/습도]가 없습니다.";
                }
            }

            if (modify_errors.length > 1)
                break;
        }

        let isValid = Date.parse(modifyWillChangeDateNH3);
        if (isNaN(isValid)) {
            modify_errors = "[교환시기 - 암모니아] 날짜 형식이 올바르지 않습니다.";
            modify_key = "willChangeDateNH3";
        }
        isValid = Date.parse(modifyWillChangeDateH2S);
        if (isNaN(isValid)) {
            modify_errors = "[교환시기 - 황화수소] 날짜 형식이 올바르지 않습니다.";
            modify_key = "willChangeDateH2S";
        }
        isValid = Date.parse(modifyWillChangeDateTH);
        if (isNaN(isValid)) {
            modify_errors = "[교환시기 - 온/습도] 날짜 형식이 올바르지 않습니다.";
            modify_key = "willChangeDateTH";
        }

        if (modify_errors.length > 1) {
            alert(modify_errors);

            if (modify_key === 'willChangeDateNH3') {
                focusRefModifyWillChangeDateNH3.current.focus();
            } else if (modify_key === 'willChangeDateH2S') {
                focusRefModifyWillChangeDateH2S.current.focus();
            } else if (modify_key === 'willChangeDateTH') {
                focusRefModifyWillChangeDateTH.current.focus();
            } else if (modify_key === 'didChangeCountNH3') {
                focusRefModifyDidChangeCountNH3.current.focus();
            } else if (modify_key === 'didChangeCountH2S') {
                focusRefModifyDidChangeCountH2S.current.focus();
            } else if (modify_key === 'didChangeCountTH') {
                focusRefModifyDidChangeCountTH.current.focus();
            }

            return;
        }

        // 센서 교환시기 : 센서 교환횟수 수정 시 - 센서 교환일도 수정
        let changeDateNH3 = "";
        let changeDateH2S = "";
        let changeDateTH = "";

        if ((deviceListInfo[selectedIndex].willChangeDateNH3 !== modifyWillChangeDateNH3) || (deviceListInfo[selectedIndex].didChangeCountNH3 !== Number(modifyDidChangeCountNH3))) {
            changeDateNH3 = getTodayDateString();
        }
        if ((deviceListInfo[selectedIndex].willChangeDateH2S !== modifyWillChangeDateH2S) || (deviceListInfo[selectedIndex].didChangeCountH2S !== Number(modifyDidChangeCountH2S))) {
            changeDateH2S = getTodayDateString();
        }
        if ((deviceListInfo[selectedIndex].willChangeDateTH !== modifyWillChangeDateTH) || (deviceListInfo[selectedIndex].didChangeCountTH !== Number(modifyDidChangeCountTH))) {
            changeDateTH = getTodayDateString();
        }

        let body = {
            id: userInfo.email,
            sensorNumber: modifyDeviceSensorNumber,
            willChangeDateNH3: modifyWillChangeDateNH3,
            willChangeDateH2S: modifyWillChangeDateH2S,
            willChangeDateTH: modifyWillChangeDateTH,
            didChangeDateNH3: changeDateNH3,
            didChangeDateH2S: changeDateH2S,
            didChangeDateTH: changeDateTH,
            didChangeCountNH3: Number(modifyDidChangeCountNH3),
            didChangeCountH2S: Number(modifyDidChangeCountH2S),
            didChangeCountTH: Number(modifyDidChangeCountTH)
        };

        let modify_msg = "";

        console.log('findDevice', body);
        dispatch(findDevice(body)).then(response => {
            if (response.payload.findSuccess) {
                console.log('updateSensor', body);
                dispatch(updateSensor(body)).then(response => {
                    if (response.payload.updateSuccess) {
                        modify_msg = "[" + userInfo.email + " (" + modifyDeviceSensorNumber + ")] 장비 정보수정 되었습니다.";
                        alert(modify_msg);
                        window.location.replace('/Management');
                    }
                });
            }
        });
    };

    const focusRefGateway = useRef();
    const focusRefAddNodeSensorNumber = useRef();
    const focusRefAddNodeSensorId = useRef();

    const [addNodeSensorNumber, setAddNodeSensorNumber] = useState('');
    const [addNodeSensorId, setAddNodeSensorId] = useState('');
    const [checkDuplicate, setCheckDuplicate] = useState(false);

    // Node Sensor [+] 추가 Modal
    const [addNodeSensorOpen, setAddNodeSensorOpen] = useState(false);
    const [selectedGateway, setSelectedGateway] = useState('');

    const handleAddNodeSensorOpen = (e) => {
        console.log('handleAddNodeSensorOpen:', userInfo);
        setSelectedGateway(userInfo.sensorMain);
        setAddNodeSensorNumber(prefixNodeSensor);
        setAddNodeSensorId('');
        setAddNodeSensorOpen(true);
    };
    const handleAddNodeSensorClose = () => setAddNodeSensorOpen(false);

    const handleGatewayChange = (event) => {
        // alert(event.target.value);
        setSelectedGateway(event.target.value);
    };

    const handleChangeAddNodeSensorNumber = (event) => {
        setAddNodeSensorNumber(event.target.value);
    };

    const handleChangeAddNodeSensorId = (event) => {
        setAddNodeSensorId(event.target.value);
    };

    const handleCheckDuplicate = (e) => {
        e.preventDefault();
        
        setCheckDuplicate(false);

        let check_error = "";

        if (selectedGateway.length === 0 || selectedGateway === undefined) {
            check_error = "[Gateway]를 선택해주세요.";
            alert(check_error);
            focusRefGateway.current.focus();
            return;
        }

        if (selectedGateway.indexOf(prefixMainSensor) < 0) {
            check_error = "[Gateway]를 선택해주세요.";
            alert(check_error);
            focusRefGateway.current.focus();
            return;
        }

        if (addNodeSensorNumber.length === 0 || addNodeSensorNumber === undefined) {
            check_error = "[Node Sensor]를 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorNumber.indexOf(prefixNodeSensor) < 0) {
            check_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorNumber.length !== setting.sensor_no_total_length) {
            check_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        const tempSensor = addNodeSensorNumber;
        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        const productNumber = Number(tempNumber);

        if (productNumber < 1 || productNumber > 999999) {
            check_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorNumber.current.focus();
            return;
        }

        if (addNodeSensorId.length === 0 || addNodeSensorId === undefined) {
            check_error = "[Node Sensor] Serial Number를 입력해주세요.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        if (addNodeSensorId.length !== setting.sensor_no_total_length + 1) {
            check_error = "[Node Sensor] Serial Number는 영.숫자 조합 16자 입니다.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        const alphaNumRegex = /^[a-z0-9]+$/;
        if (!alphaNumRegex.test(addNodeSensorId)) {
            check_error = "[Node Sensor] Serial Number는 영문자(a–z)와 숫자(0–9)로만 구성되어야 합니다.";
            alert(check_error);
            focusRefAddNodeSensorId.current.focus();
            return;
        }

        let body = {
            sensor: addNodeSensorNumber
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            console.log(response);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    check_error = "[Node Sensor] 이미 해당 제품순번이 존재합니다.";
                    alert(check_error);
                    focusRefAddNodeSensorNumber.current.focus();
                    return;
                }
            } else {
                body = {
                    sensorId: addNodeSensorId
                };

                console.log('findSensorId', body);
                dispatch(findSensorId(body)).then(response => {
                    console.log(response);
                    if (response.payload.findSuccess) {
                        check_error = "[Node Sensor] Serial Number가 이미 사용중입니다. 한번 더 확인해주세요.";
                        alert(check_error);
                        focusRefAddNodeSensorId.current.focus();
                        return;
                    } else {
                        check_error = "[Node Sensor] 추가를 위한 모든 정보 입력이 완료되었습니다.";
                        alert(check_error);
                        setCheckDuplicate(true);
                    }
                });
            }
        })
        .catch((err) => console.log(err));
    };

    const handleAddNodeSensor = (e) => {
        let add_msg = "";

        if (!checkDuplicate) {
            add_msg = "[Gateway] 선택 및 [Node Sensor] 정보 입력 후 [중복확인]을 먼저 진행하세요.";
            alert(add_msg);
            focusRefGateway.current.focus();
            return;
        }

        const confirmAdd = window.confirm("정말로 [Node Sensor]를 추가하시겠습니까?");
        if (confirmAdd) {
            // 사용자가 'Yes'를 클릭한 경우, 추가 작업을 진행
            let body = {
                gateway: selectedGateway
            };

            console.log('findGateway', body);
            dispatch(findGateway(body)).then(response => {
                console.log(response);
                if (response.payload.findSuccess) {
                    let gateway = response.payload.userInfo;
                    let sensorNode = gateway.sensorNode;
                    console.log('sensorNode:', sensorNode);
                    const newSensorNode = {
                        id: sensorNode.length,
                        value: addNodeSensorNumber,
                        device: addNodeSensorId
                    };
                    sensorNode.push(newSensorNode);
                    console.log('newSensorNode:', sensorNode);

                    body = {
                        gateway: selectedGateway,
                        sensorNode: sensorNode
                    };

                    dispatch(updateGateway(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: gateway.email,
                                sensorNumber: addNodeSensorNumber,
                                sensorId: addNodeSensorId,
                                willChangeDateNH3: f_willChangeDate(Number(setting.sensor_lifetime_nh3)),
                                willChangeDateH2S: f_willChangeDate(Number(setting.sensor_lifetime_h2s)),
                                willChangeDateTH: f_willChangeDate(Number(setting.sensor_lifetime_th)),
                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                            };

                            dispatch(registerDevice(body)).then(response => {
                                if (response.payload.registerSuccess) {
                                    let deviceInfo = response.payload.deviceInfo;
                                    add_msg = "[" + deviceInfo.sensorNumber + " (" + deviceInfo.id + ")] Node Sensor 추가 되었습니다.";
                                    alert(add_msg);
                                    window.location.replace('/Management');
                                }
                            });
                        }
                    });
                } else {
                    console.log("No Gateway...");
                }
            });
        } else {
            // 사용자가 'No'를 클릭한 경우
            console.log("Node Sensor Add Cancel...");
        }
    };

    const f_willChangeDate = (c_month) => {
        let today = new Date();
        let change_day = new Date();

        change_day.setMonth(today.getMonth() + c_month);

        let year = change_day.getFullYear();
        let month = ('0' + (change_day.getMonth() + 1)).slice(-2);
        let day = ('0' + change_day.getDate()).slice(-2);

        let change_date = year + '-' + month + '-' + day;

        return change_date;
    };

    // Node Sensor [-] 삭제 Modal
    const [deleteNodeSensorNumber, setDeleteNodeSensorNumber] = useState('');
    const [deleteNodeSensorId, setDeleteNodeSensorId] = useState('');

    const [deleteNodeSensorOpen, setDeleteNodeSensorOpen] = useState(false);

    const handleDeleteNodeSensorOpen = (e) => {
        alert_msg = "";
        if (checkedList.length === 0) {
            alert_msg = "삭제할 [Node Sensor]를 선택해주세요.";
        } else if (checkedList.length !== 1) {
            alert_msg = "안전한 처리를 위해 [Node Sensor] 하나만 선택해주세요.";
        }
        if (alert_msg.length > 1) {
            alert(alert_msg);
            return;
        }

        setDeleteNodeSensorNumber(deviceListInfo[selectedIndex].sensorNumber);
        setDeleteNodeSensorId(deviceListInfo[selectedIndex].sensorId);
        setDeleteNodeSensorOpen(true);
    };
    const handleDeleteNodeSensorClose = () => setDeleteNodeSensorOpen(false);

    const handleDeleteNodeSensor = (e) => {
        let delete_msg = "";

        const confirmDelete = window.confirm("정말로 [Node Sensor]를 삭제하시겠습니까?");
        if (confirmDelete) {
            // 사용자가 'Yes'를 클릭한 경우, 추가 작업을 진행
            let body = {
                gateway: userInfo.sensorMain
            };

            console.log('findGateway', body);
            dispatch(findGateway(body)).then(response => {
                console.log(response);
                if (response.payload.findSuccess) {
                    let gateway = response.payload.userInfo;
                    let sensorNode = gateway.sensorNode;
                    console.log('sensorNode:', sensorNode);

                    let updatedSensorNode = sensorNode.filter(node => node.value !== deleteNodeSensorNumber);
                    console.log('Updated sensorNode:', updatedSensorNode);

                    body = {
                        gateway: userInfo.sensorMain,
                        sensorNode: updatedSensorNode
                    };

                    dispatch(updateGateway(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: gateway.email,
                                sensorNumber: deleteNodeSensorNumber,
                                sensorId: deleteNodeSensorId
                            };

                            dispatch(deleteDevice(body)).then(response => {
                                if (response.payload.deleteSuccess) {
                                    let deletedCount = response.payload.deletedCount;
                                    if (deletedCount > 0) {
                                        delete_msg = "[" + deleteNodeSensorNumber + " (" + deleteNodeSensorId + ")] Node Sensor 삭제 되었습니다.";
                                        alert(delete_msg);
                                        window.location.replace('/Management');
                                    }
                                }
                            });
                        }
                    });
                } else {
                    console.log("No Gateway...");
                }
            });
        } else {
            // 사용자가 'No'를 클릭한 경우
            console.log("Node Sensor Delete Cancel...");
        }
    };

    return (
        <>
        <div className="ManagementTable">
            <ul className="ManagementTableTh">
                <li>선택</li>
                <li>장비 Part No.</li>
                <li>등록일</li>
                <li>장비상태</li>
                <li className="textChange">센서 교환시기</li>
                <li className="textChange2">센서 교환횟수</li>
                <li>무상 AS 만료일</li>
            </ul>
        {
            deviceListInfo.map((detail, index) => (
            <ul
                className="ManagementTableTd"
                key={detail.sensorNumber || index}>
                <li>
                    <FormControl>
                        <FormGroup
                            id="listSelect"
                            name="listSelect"
                            value={index}
                            onChange={(e) => onCheckedElement(e.target.checked, detail, index)}
                            checked={checkedList.includes(detail) ? true : false}
                            row
                            aria-labelledby="list-row-radio-buttons-group-label"
                        >
                            <FormControlLabel value={index} control={<Checkbox />} label={index + 1} />
                        </FormGroup>
                    </FormControl>
                </li>
                <li>{detail.sensorNumber}</li>
                <li>{detail.registerDate}</li>
                <li className="textOnline"
                    style={{
                        color: 
                            detail.state === "Online" ? '#1a9f55' :       // 녹색: 정상동작
                            detail.state === "Offline" ? '#d9822b' :      // 주황색: 점검필요
                            detail.state === "Error" ? '#e02424' :        // 빨간색: 통신오류
                            '#999999'                                     // 회색: 대기상태 or 없음
                    }}
                >
                    {detail.state === "" && "대기상태"}
                    {detail.state === "Online" && "정상동작"}
                    {detail.state === "Offline" && "점검필요"}
                    {detail.state === "Error" && "통신오류"}
                </li>
                <li className="textChange">
                    <p>암모니아&nbsp;&nbsp;
                        {detail.willChangeDateNH3}</p>
                    <p>황화수소&nbsp;&nbsp;
                        {detail.willChangeDateH2S}</p>
                    <p>온/습도&nbsp;&nbsp;&nbsp;&nbsp;
                        {detail.willChangeDateTH}</p>
                </li>
                <li className="textChange2">
                    <p>{detail.didChangeCountNH3}</p>
                    <p>{detail.didChangeCountH2S}</p>
                    <p>{detail.didChangeCountTH}</p>
                </li>
                <li>{detail.guaranteeExpirationDate}</li>
            </ul>
            ))
        }
        </div>
        <div className="ManagementBtn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {/* 왼쪽 정렬 버튼 그룹 */}
            <div className="LeftButtons" style={{ display: 'flex', gap: '8px' }}>
                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}} 
                        variant="outlined"
                        onClick={handleAddNodeSensorOpen}>
                        Sensor [+] 추가
                </Button>
                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}} 
                        variant="outlined"
                        onClick={handleDeleteNodeSensorOpen}>
                        Sensor [-] 삭제
                </Button>
            </div>

            {/* 오른쪽 정렬 버튼 그룹 */}
            <div className="RightButtons" style={{ display: 'flex', gap: '8px' }}>
                <CSVLink
                    headers={headers}
                    data={arrayPrints}
                    target="_blank"
                    filename={`장비_리스트_${moment().format('YYYYMMDD')}_${moment().format('HHMMSS')}`}>
                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color: 'white'}}
                            onClick={handlePrintSubmit}
                            variant="outlined">
                            출 력
                    </Button>
                </CSVLink>
                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 32px', border: 'none', color:'white'}} 
                        variant="outlined"
                        onClick={handleModifyDeviceOpen}>
                        수 정
                </Button>
            </div>
        </div>
        <Modal
            open={modifyDeviceOpen}
            onClose={handleModifyDeviceClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box sx={{ ...style, width: 600, height: 800 }}>
                <Typography className="modalCloseIcon">
                    <CloseIcon onClick={handleModifyDeviceClose}/>
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    장비 수정
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <div className="ManagementBody">
                    <div>
                        <div className="textInputListFull">
                            <span className="subListText">장비 Part No.</span>
                            <input
                                id="modifyDeviceSensorNumber"
                                name="modifyDeviceSensorNumber"
                                className="textInputAD"
                                type="text"
                                value={modifyDeviceSensorNumber}
                                readOnly />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListTextDetail">센서 교환시기</span>
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">암모니아</span>
                            <input
                                id="modifyWillChangeDateNH3"
                                name="modifyWillChangeDateNH3"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyWillChangeDateNH3}
                                value={modifyWillChangeDateNH3} />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">황화수소</span>
                            <input
                                id="modifyWillChangeDateH2S"
                                name="modifyWillChangeDateH2S"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyWillChangeDateH2S}
                                value={modifyWillChangeDateH2S} />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">온/습도</span>
                            <input
                                id="modifyWillChangeDateTH"
                                name="modifyWillChangeDateTH"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyWillChangeDateTH}
                                value={modifyWillChangeDateTH} />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListTextDetail">센서 교환횟수</span>
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">암모니아</span>
                            <input
                                id="modifyDidChangeCountNH3"
                                name="modifyDidChangeCountNH3"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyDidChangeCountNH3}
                                value={modifyDidChangeCountNH3} />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">황화수소</span>
                            <input
                                id="modifyDidChangeCountH2S"
                                name="modifyDidChangeCountH2S"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyDidChangeCountH2S}
                                value={modifyDidChangeCountH2S} />
                        </div>
                        <div className="textInputListFull">
                            <span className="subListText">온/습도</span>
                            <input
                                id="modifyDidChangeCountTH"
                                name="modifyDidChangeCountTH"
                                className="textInputAD"
                                type="text"
                                onChange={handleChangeModifyDevice}
                                ref={focusRefModifyDidChangeCountTH}
                                value={modifyDidChangeCountTH} />
                        </div>
                    </div>
                    
                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                            onClick={handleModifyDeviceSubmit}
                            variant="outlined">
                            수 정
                    </Button>
                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                            onClick={handleModifyDeviceClose}
                            variant="outlined">
                            취 소
                    </Button>
                </div>
                </Typography>                                 
            </Box>
        </Modal>
        {/* Sensor [+] 추가 Modal */}
        <Modal
            open={addNodeSensorOpen}
            onClose={handleAddNodeSensorClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box sx={{ ...style, width: 900, height: 400 }}>
                <Typography className="modalCloseIcon" component="div">
                    <CloseIcon onClick={handleAddNodeSensorClose} style={{ marginTop: '0px' }} />
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h1">
                    Node Sensor [+] 추가
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                    <div className="RegistrationBody">
                        <div className="textInputListFull">
                            <div className="sensorWrap">
                                <span className="sensor">Gateway</span>
                                <Select 
                                    labelId="device-select-label"
                                    value={selectedGateway} 
                                    onChange={handleGatewayChange}
                                    ref={focusRefGateway}
                                    style={{ marginLeft: '46px', borderRadius: '8px' }}
                                >
                                    <MenuItem
                                        value={selectedGateway}
                                        readOnly
                                    >
                                            {selectedGateway}
                                    </MenuItem>
                                </Select>
                            </div>
                        </div>
                        <div className="textInputListFull">
                            <div className="sensorWrap">
                                <span className="sensor">Node Sensor</span>
                                <input
                                    id={`addNodeSensorNumber`}
                                    name={`addNodeSensorNumber`}
                                    value={addNodeSensorNumber}
                                    onChange={handleChangeAddNodeSensorNumber}
                                    ref={focusRefAddNodeSensorNumber}
                                    required
                                    className="textInputId"
                                    type="text"
                                    maxLength={15}
                                    placeholder="EMS01-NS-000001" />
                                <input
                                    id={`addNodeSensorId`}
                                    name={`addNodeSensorId`}
                                    value={addNodeSensorId}
                                    onChange={handleChangeAddNodeSensorId}
                                    ref={focusRefAddNodeSensorId}
                                    required
                                    className="textInputId"
                                    type="text"
                                    maxLength={16} />
                                <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                        onClick={handleCheckDuplicate}
                                        variant="outlined">
                                        중복확인
                                </Button>
                            </div>
                        </div>
                        <div className="textInputListFull">
                            <div className="sensorWrap">
                                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                        onClick={handleAddNodeSensor}
                                        variant="outlined">
                                        Node Sensor [+] 추가하기
                                </Button>
                                <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                        onClick={handleAddNodeSensorClose}
                                        variant="outlined">
                                        취 소
                                </Button>
                            </div>
                        </div>
                    </div>
                </Typography>                                 
            </Box>
        </Modal>
        {/* Sensor [-] 삭제 Modal */}
        <Modal
            open={deleteNodeSensorOpen}
            onClose={handleDeleteNodeSensorClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box sx={{ ...style, width: 900, height: 300 }}>
                <Typography className="modalCloseIcon" component="div">
                    <CloseIcon onClick={handleDeleteNodeSensorClose} style={{ marginTop: '0px' }} />
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h1">
                    Node Sensor [-] 삭제
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                    <div className="RegistrationBody">
                        <div className="textInputListFull">
                            <div className="sensorWrap">
                                <span className="sensor">Node Sensor</span>
                                <input
                                    id={`deleteNodeSensorNumber`}
                                    name={`deleteNodeSensorNumber`}
                                    value={deleteNodeSensorNumber}
                                    disabled
                                    className="textInputId"
                                    type="text"
                                    maxLength={15}
                                    placeholder="EMS01-NS-000001" />
                                <input
                                    id={`deleteNodeSensorId`}
                                    name={`deleteNodeSensorId`}
                                    value={deleteNodeSensorId}
                                    disabled
                                    className="textInputId"
                                    type="text"
                                    maxLength={16} />
                            </div>
                        </div>
                        <div className="textInputListFull">
                            <div className="sensorWrap">
                                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                        onClick={handleDeleteNodeSensor}
                                        variant="outlined">
                                        Node Sensor [-] 삭제하기
                                </Button>
                                <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}} 
                                        onClick={handleDeleteNodeSensorClose}
                                        variant="outlined">
                                        취 소
                                </Button>
                            </div>
                        </div>
                    </div>
                </Typography>                                 
            </Box>
        </Modal>
        </>
    );
};

export default Detail;
